import React from 'react';
import { SectionLabel } from './SectionLabel';
import { AccordionGroup, AccordionRow } from './Accordion';
import { questions } from '../data/questions';
export function Questions() {
  return <section className="py-32 px-6 md:px-12 lg:px-24 max-w-5xl mx-auto border-t border-ink/10" data-id="element-64" data-mp="33bzvty30vgal">
      <SectionLabel title="Questions" className="mb-16" data-id="element-65" data-mp="38c5e4nnejqg0" />

      <AccordionGroup data-id="element-66" data-mp="389j7cq8c5eyu">
        {questions.map(item => <AccordionRow key={item.title} title={item.title} body={item.body} data-id="element-67" data-mp="3d9nrcq8gcrtt" />)}
      </AccordionGroup>
    </section>;
}